import {Injectable} from "@angular/core";

@Injectable()
export class EmailValidatorService {

    validate(email) {
        const regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regExp.test(email);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/email-validator.service.ts